export default {
    select_size: "Select a size",
    required: "required",
  };
  